module.exports = __webpack_public_path__ + "static/media/0008.2ca916b0.jpg";